import React from "react";
import {
  DateField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
} from "react-admin";

const CulturesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <ReferenceField
        label="Sample"
        resource="cultures"
        source="id_sample"
        reference="samples"
        link="show"
      >
        <TextField source="code" />
      </ReferenceField>
      <TextField label="Culture code" source="code" />
      <DateField
        source="culture_date"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
      />
      <ReferenceField
        label="Culture Medium"
        source="id_culture_medium"
        reference="culture_media"
        link={false}
      >
        <TextField source="culture_medium" />
      </ReferenceField>
      <TextField source="atmosphere" />
      <NumberField source="num_isolates" />
      <NumberField source="temperature" />
      <TextField source="time_culture" />

      <TextField source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
    </SimpleShowLayout>
  </Show>
);

export default CulturesShow;
